module.exports = __webpack_public_path__ + "img/img_t1@2x.66b884fc.png";